import { render, staticRenderFns } from "./AlertConfirm.vue?vue&type=template&id=baf1e5fa&scoped=true&"
import script from "./AlertConfirm.vue?vue&type=script&lang=js&"
export * from "./AlertConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf1e5fa",
  null
  
)

export default component.exports